import Head from "next/head";
import { CoverageScreen } from "@medbillai/app/screens/coverage/screen";
import { HomeLayout } from "@medbillai/app/screens/home/layout.web";
import { AuthGate } from "../../utils/AuthGate";
import type { NextPageWithLayout } from "../_app";
const Page: NextPageWithLayout = () => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
        <title>Coverage</title>
      </Head>
      <CoverageScreen data-sentry-element="CoverageScreen" data-sentry-source-file="index.tsx" />
    </>;
};
Page.getLayout = page => <AuthGate>
    <HomeLayout fullPage>{page}</HomeLayout>
  </AuthGate>;
export default Page;